import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { InputWrapper } from '../../../common/input-wrapper';
import { decimalValidation } from '../../../../utils/validations';
import { Input } from '../../../common/input.component';
import classNames from 'classnames';
import useSWR from 'swr';
import { trpc } from '../../../../api/trpc';

type Props = {
  close: () => void;
  reject: () => void;
  defaultValues?: Form;
  onSubmit: (data: Form) => Promise<void>;
  title: string;
};

type Form = {
  rate: number;
  fromAmount?: number;
  toAmount?: number;
  type: FormType;
};

type FormType = 'forApply' | 'forOrder';

export const CustomsDeliveryTrueSignEditModal: React.FC<Props> = ({
  defaultValues,
  onSubmit,
  title,
  ...props
}) => {
  const [type, setType] = useState<FormType>(defaultValues?.type || 'forApply');
  const input = { type: type };
  const { mutate: mutateList } = useSWR(
    ['customsDeliveryTrueSign.getList', input],
    () => trpc.customsDeliveryTrueSign.getList.query(input),
  );
  const {
    register,
    formState: { errors, isSubmitting },
    handleSubmit,
  } = useForm<Form>({
    defaultValues: defaultValues,
  });

  const intl = useIntl();

  const submit = handleSubmit(async (data) => {
    await onSubmit({
      toAmount: data.toAmount ? +data.toAmount : undefined,
      rate: +data.rate,
      fromAmount: data.fromAmount ? +data.fromAmount : undefined,
      type: type,
    });
    mutateList();
    props.close();
  });

  return (
    <div className="modal-dialog">
      <form className="modal-content" onSubmit={submit}>
        <div className="modal-header border-bottom-0 p-4">
          <h3>{title}</h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => props.reject()}
          />
        </div>

        <div className="modal-body pt-2 p-4">
          <div className={'d-flex gap-2 border-bottom border-gray-300 pb-1'}>
            <div
              className={classNames(
                'btn ',
                type === 'forApply' ? 'btn-success' : 'btn-secondary',
              )}
              onClick={() => {
                setType('forApply');
              }}
            >
              Нанесение
            </div>
            <div
              className={classNames(
                'btn btn-secondary ',
                type === 'forOrder' ? 'btn-success' : 'btn-secondary',
              )}
              onClick={() => {
                setType('forOrder');
              }}
            >
              Заказ
            </div>
          </div>

          <InputWrapper
            title={intl.formatMessage({
              defaultMessage: 'Ставка, ₽',
              id: 'customsDeliveryTrueSignEditModal.input-label.rate',
              description: 'Заголовок поля ввода',
            })}
            className="mb-3"
            error={errors.rate?.message}
          >
            <Input {...register('rate')} postfix="₽" />
          </InputWrapper>
          <div className={'d-flex gap-2'}>
            <InputWrapper
              title={intl.formatMessage({
                defaultMessage: 'от',
                id: 'customsDeliveryTrueSignEditModal.input-label.fromPrice',
                description: 'Заголовок поля ввода',
              })}
              className="mb-3"
              error={errors.fromAmount?.message}
            >
              <Input
                {...register('fromAmount', {
                  ...decimalValidation,
                })}
                min={0.01}
                step={0.01}
                postfix="шт"
              />
            </InputWrapper>
            <InputWrapper
              title={intl.formatMessage({
                defaultMessage: 'до',
                id: 'customsDeliveryTrueSignEditModal.input-label.toPrice',
                description: 'Заголовок поля ввода',
              })}
              className="mb-3"
              error={errors.toAmount?.message}
            >
              <Input
                {...register('toAmount', {
                  ...decimalValidation,
                })}
                min={0.1}
                step={0.1}
                postfix="шт"
              />
            </InputWrapper>
          </div>
        </div>
        <div className="modal-footer justify-content-end">
          <button
            type="submit"
            className="btn btn-success"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <FormattedMessage
                defaultMessage="Сохранить"
                id="customsDeliveryTrueSignEditModal.status-label.save"
                description="Надпись на кнопке"
              />
            )}
          </button>
        </div>
      </form>
    </div>
  );
};
